import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import s from './onboarding.module.scss';
import { Button } from '@shared/ui/button/button';
import { TextWithEmoji } from '@shared/ui/text-with-emoji/text-with-emoji';
import { useAllInstruments } from '@shared/api/useAllInstruments';
import { useProfile } from '@shared/api/useProfile';
import { useUpdateInstruments } from '@entities/profile/api/useUpdateInstruments';
import { OnboardingOptionCard } from '@shared/ui/onboarding-option-card';
import { itemVariants, sectionVariants } from '@shared/lib/onboarding-motion';

export const Instrument = React.memo(({ setCurrentStep }) => {
	const { data: instruments } = useAllInstruments();
	const { data: profile } = useProfile();
	const { mutate: updateProfile, isPending } = useUpdateInstruments();

	const [selectedInstruments, setSelectedInstruments] = useState(
		() => profile?.instruments?.map((item) => item.id) || []
	);

	const flatInstruments = useMemo(
		() =>
			instruments?.flatMap((group) =>
				(group?.instruments || []).map((instrument) => ({
					...instrument,
					groupName: group?.name,
				}))
			) || [],
		[instruments]
	);

	const toggleInstrument = (id) => {
		setSelectedInstruments((prev) =>
			prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
		);
	};

	const onSubmit = () => {
		updateProfile(
			{ instruments: selectedInstruments },
			{
				onSuccess: () => setCurrentStep((prev) => prev + 1),
			}
		);
	};

	return (
		<motion.div className={s.slideWrapper} variants={sectionVariants} initial="initial" animate="animate">
			<motion.div className={s.titleWrapper} variants={itemVariants}>
				<p className={s.title}>Выбор инструмента</p>
				<p className={s.subtitle}>
					Выберите инструменты, на которых вы хотите преподавать. <br />
					Этот список можно будет редактировать в настройках
				</p>
			</motion.div>
			<motion.div className={s.goalOptionsGrid} variants={sectionVariants}>
				{flatInstruments.map((instrument) => (
					<OnboardingOptionCard
						key={instrument.id}
						checked={selectedInstruments.includes(instrument.id)}
						onClick={() => toggleInstrument(instrument.id)}
					>
						<TextWithEmoji text={instrument.name} />
					</OnboardingOptionCard>
				))}
			</motion.div>
			<motion.div className={s.btns} variants={itemVariants}>
				<Button
					label="Пропустить"
					size="small"
					theme="secondary"
					className={s.button}
					onClick={() => setCurrentStep((prev) => prev + 1)}
				/>
				<Button
					label="Далее"
					size="small"
					className={s.button}
					disabled={selectedInstruments.length <= 0}
					fetching={isPending}
					onClick={onSubmit}
				/>
			</motion.div>
		</motion.div>
	);
});
